import React, {Component} from 'react';
import {Button, Card, CardBody, Col, Row} from 'reactstrap';

class DeleteProjectForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error:           '',
			property_number: ''
		};

		this.deleteProject = this.deleteProject.bind(this);
	}

	deleteProject() {
		this.props.setLoading(true);
		let authHeaders = this.props.md5PostXAuthHeaders();
		const dataURL = `${this.props.apiPrefix}/bronco/legacy/donkey/delete/`;
		let postObj = {};
		postObj.prop_num = this.props.route;
		let errorCheck = false;

		fetch(dataURL, {
			body:    JSON.stringify(postObj),
			method:  'POST',
			headers: Object.assign(
				{'content-type': 'application/json'},
				authHeaders
			)
		})
			.catch((error) => {
				errorCheck = true;
				this.props.setLoading(false);
				this.setState({
					error: `${error} -- Please check your network connection.`
				});
			})
			.then((response) => {
				if (errorCheck) {
					this.props.setLoading(false);
					return;
				}

				return response.json();
			})
			.catch((error) => {
				errorCheck = true;
				this.props.setLoading(false);
				this.setState({
					error: `The server response has the following issue -- ${error}`
				});
			})
			.then((usefulJson) => {
				if (errorCheck) {
					return;
				}
				this.setState(
					{property_number: usefulJson.data.property_number},
					() => {
						this.props.setLoading(false);
						this.props.changeModalSubsection('SUBMITTED');
					}
				);
			});
	}

	render() {
		switch (this.props.createModalSubsection) {
		case 'ERROR':
			return (
				<div>
					<p>An error was encountered: {this.state.error}</p>
				</div>
			);
		case 'SUBMITTED':
			return (
				<Card>
					<CardBody>
						<h2 className="h2">
                Successfully deleted the project with Property Number:{' '}
							{this.state.property_number}
						</h2>
						<Button
							color="success"
							onClick={() => {
								this.props.goBackToSplash();
								this.props.toggleCreateModal();
							}}
						>
                Return Home
						</Button>
					</CardBody>
				</Card>
			);
		case 'MAIN':
		default:
			return (
				<div>
					<Row>
						<Col>
							<p>
                  Are you sure you want to delete this project and all
                  associated records?
							</p>
							<Button color="danger" onClick={this.deleteProject}>
                  Confirm Delete
							</Button>
						</Col>
					</Row>
				</div>
			);
		}
	}
}

export default DeleteProjectForm;



// WEBPACK FOOTER //
// ./src/components/DeleteProjectForm.js